import {
  GET_CODE_LISTING_MANAGEMENT,
  GET_CODE_LISTING_MANAGEMENT_SUCCESS,
  GET_CODE_LISTING_MANAGEMENT_FAILURE,
  GET_SCHOOLNAME_FILTER,
  GET_SCHOOLNAME_FILTER_SUCCESS,
  GET_SCHOOLNAME_FILTER_FAILURE,
} from "../../Actions/types";

const initialState = {
  getcodelistingLoader: false,
  codedata: [],
  codeerror: false,
  getschoolnamedata: [],
  getschoolnameloader: false,
  schoolnameerror: false,
};
function codeManagementReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CODE_LISTING_MANAGEMENT:
      return { ...state, getcodelistingLoader: true };
    case GET_CODE_LISTING_MANAGEMENT_SUCCESS:
      return {
        ...state,
        codedata: action?.payload,
        getcodelistingLoader: false,
      };
    case GET_CODE_LISTING_MANAGEMENT_FAILURE:
      return {
        ...state,
        getcodelistingLoader: false,
        codeerror: true,
      };

    case GET_SCHOOLNAME_FILTER:
      return {
        ...state,
        getschoolnameloader: true,
      };

    case GET_SCHOOLNAME_FILTER_SUCCESS:
      return {
        ...state,
        getschoolnamedata: action?.payload,
        getschoolnameloader: false,
      };

    case GET_SCHOOLNAME_FILTER_FAILURE:
      return {
        ...state,
        getschoolnameloader: false,
        schoolnameerror: true,
      };

    default:
      return state;
  }
}

export default codeManagementReducer;
